﻿document.addEventListener('alpine:init', () => {
	Alpine.data('global', () => ({
	}))
}); 